import type {
  StudentPortfolioAssignmentShallowResource,
  StudentPortfolioAssignmentShallowResourceMeta,
} from "api/generated";
import type {
  StudentShallowAssignment,
  StudentShallowAssignmentMeta,
} from "portfolio/types";
import { portfolioShallowStudentTaskFromDto } from "./portfolioShallowTask.mapper";

export const studentShallowAssignmentFromDto = (
  data: StudentPortfolioAssignmentShallowResource,
): StudentShallowAssignment => ({
  id: data.id,
  status: data.status,
  concept: data.concept,
  assessmentStatus: data.assessment_status,
  deadline: data.deadline ? new Date(data.deadline) : null,
  completedAt: data.completed_at ? new Date(data.completed_at) : null,
  submittedAt: data.submitted_at ? new Date(data.submitted_at) : null,
  assessedAt: data.assessed_at ? new Date(data.assessed_at) : null,
  task: portfolioShallowStudentTaskFromDto(data.task),
  meta: metaFromDto(data.meta),
});

const metaFromDto = (
  data: StudentPortfolioAssignmentShallowResourceMeta,
): StudentShallowAssignmentMeta => ({
  allowCreate: data.allow_create,
  allowEdit: data.allow_edit,
  allowRetry: data.allow_retry,
});
